export var HdsIconlibraryThirdPartyLogos_8px;
(function (HdsIconlibraryThirdPartyLogos_8px) {
    HdsIconlibraryThirdPartyLogos_8px["What_3WordsOutline_8px"] = "what-3-words_outline_8px";
    HdsIconlibraryThirdPartyLogos_8px["What_3WordsSolid_8px"] = "what-3-words_solid_8px";
})(HdsIconlibraryThirdPartyLogos_8px = HdsIconlibraryThirdPartyLogos_8px || (HdsIconlibraryThirdPartyLogos_8px = {}));
export const HDS_ICONLIBRARY_THIRD_PARTY_LOGOS_8PX_CODEPOINTS = {
    [HdsIconlibraryThirdPartyLogos_8px.What_3WordsOutline_8px]: '61697',
    [HdsIconlibraryThirdPartyLogos_8px.What_3WordsSolid_8px]: '61698',
};
//# sourceMappingURL=hds-iconlibrary-third-party-logos-8px.js.map